// extracted by mini-css-extract-plugin
export var circle = "_n-2";
export var icon = "_n-a";
export var iconHighlight = "_n-0";
export var lg = "_n-8";
export var md = "_n-7";
export var outline = "_n-4";
export var sm = "_n-6";
export var square = "_n-1";
export var xl = "_n-9";
export var xs = "_n-5";
export var xxs = "_n-3";